import {LayoutIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 54 60"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "m50 25.42 4 2.366V59.25H0V27.786l4-2.365v2.375l-1 .586 1 .596 1 .593V3.725h30.679V5.78H7V30.75L27 42.6l20-11.85V15.623h2V29.57l2-1.189-1-.586zM33.686 41.012 27 44.972l-6.685-3.96-16.79 16.182h46.95zM2 55.845l16.503-15.907L2 30.161zm33.496-15.907L52 55.846V30.16z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M47.996.75 24.872 24.047l-8.386-8.927L13.5 18.48l11.289 12.017L50.894 4.194z"
    }, null, -1)
  ]))]))
}
export default { render() { return h(LayoutIcon, {icon: {render}, name: "mail_open"}) } }